import { authenticatedGet, authenticatedPost, authenticatedPut, authenticatedFetch } from "../../api/authenticatedFetch";

const BASE = "/api/v1/invoices";

// listInvoices returns invoices in the given status (comma list allowed), newest first.
export const listInvoices = async (status = "pending,needs_review") => {
  const res = await authenticatedGet(BASE, { status });
  return res?.invoices ?? [];
};

// getInvoice returns one invoice's detail incl. raw_email_base64.
export const getInvoice = async (id) => {
  const res = await authenticatedGet(`${BASE}/${id}`);
  return res?.invoice ?? res;
};

// confirmInvoice applies finance's (possibly edited) fields and marks it confirmed.
export const confirmInvoice = async (id, fields) => authenticatedPost(`${BASE}/${id}/confirm`, fields);

// rejectInvoice rejects with an optional note.
export const rejectInvoice = async (id, note) => authenticatedPost(`${BASE}/${id}/reject`, { note });

export const getInvoiceStats = async () => (await authenticatedGet(`${BASE}/stats`))?.stats ?? null;
export const getInvoiceCounts = async () => (await authenticatedGet(`${BASE}/counts`))?.counts ?? null;
export const getAutomation = async () => (await authenticatedGet(`${BASE}/automation`))?.automation ?? { enabled: true };
export const setAutomation = async (patch) => (await authenticatedPut(`${BASE}/automation`, patch))?.automation ?? patch;
export const getAttachments = async (id) => (await authenticatedGet(`${BASE}/${id}/attachments`))?.attachments ?? [];

// fetchAttachmentBlob returns a Blob for inline preview (authenticated → object URL at the call site).
export const fetchAttachmentBlob = async (id, idx) => {
  const res = await authenticatedFetch(`${BASE}/${id}/attachments/${idx}`, { method: "GET" });
  return res.blob();
};
